export default __webpack_public_path__ + "static/about-136b4e87d2258c12682971fe1f82e5cd.png";